import type { ActivityCompetencyDTO, CompetencyDTO } from '../dto/competency.dto';
import type { ICompetencyItem } from '../competency';

export const mapActivityCompetencyDTOToItem = (dto: ActivityCompetencyDTO): ICompetencyItem => ({
  id: dto.competency.id,
  name: dto.competency.name,
  description: dto.competency.description,
  externalId: dto.competency.externalId,
  sector: dto.competency.sector,
  date: new Date().toISOString(),
  categories: [],
});

/** Activity competency row mapped for the competency picker modal (includes level). */
export const mapActivityCompetencyToModalItem = (dto: ActivityCompetencyDTO): ICompetencyItem => ({
  ...mapActivityCompetencyDTOToItem(dto),
  level: dto.level,
}); 